import React from 'react';

export const EditIcon: React.FC = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="inherit"
    height="inherit"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    color="inherit"
  >
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
      <path
        d="M4458 5104 c-120 -29 -170 -64 -366 -257 l-183 -181 378 -378 378
 -378 181 182 c154 156 186 194 216 255 132 266 21 590 -245 717 -116 55 -240
 69 -359 40z"
      />
      <path
        d="M750 4633 c-347 -58 -631 -318 -722 -663 l-23 -85 0 -1565 0 -1565
 23 -83 c96 -352 385 -611 737 -662 58 -8 507 -10 1605 -8 l1525 3 80 23 c308
 87 542 316 637 623 l23 74 3 1130 c1 622 0 1140 -3 1152 -8 33 -65 94 -102
 109 -41 18 -95 18 -136 0 -37 -15 -94 -76 -102 -109 -3 -12 -6 -515 -8 -1117
 l-2 -1095 -26 -71 c-66 -180 -219 -318 -391 -353 -37 -8 -504 -11 -1573 -9
 l-1520 3 -60 22 c-171 65 -309 221 -344 391 -8 37 -11 508 -11 1550 0 1651 -4
 1550 62 1676 42 80 146 183 223 220 134 65 44 61 1245 63 602 2 1105 5 1117 8
 33 8 94 65 109 102 27 64 14 135 -34 186 -57 61 18 57 -1194 56 -612 -1 -1124
 -4 -1138 -6z"
      />
      <path
        d="M2863 3618 l-793 -793 -135 -405 c-91 -272 -135 -419 -135 -448 0
 -94 62 -162 155 -170 48 -4 95 10 462 132 l408 136 795 795 795 795 -375 375
 c-206 206 -377 375 -380 375 -3 0 -362 -357 -797 -792z"
      />
    </g>
  </svg>
);
